module.exports = __webpack_public_path__ + "static/media/mc.0f313845.svg";